import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames'
import createReactClass from 'create-react-class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'

import { withGettext } from 'lib/gettext'
import { BranchMixin } from 'legacy/libs/baobab-react-mixins'
import { Input, FormComponentMixin } from 'legacy/libs/react-form-tools'

import s from './year-select.module.scss'

const YearSelect = createReactClass({
  mixins: [BranchMixin, FormComponentMixin],

  propTypes: {
    gettext: PropTypes.func.isRequired,
    canValueBeDiscarded: PropTypes.bool,
    onChange: PropTypes.func,
    classNameMod: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    nullable: PropTypes.bool,
  },

  contextTypes: {
    form: PropTypes.object,
  },

  cursors(props, context) {
    return {
      value: this.getCursor(props, context),
      sign: this.getSignCursor(props, context),
    }
  },

  getDefaultProps() {
    return {
      onChange: _.identity,
      canValueBeDiscarded: false,
    }
  },

  getSignCursor(props, context) {
    props = props || this.props
    context = context || this.context

    if (props.signCursor) {
      return props.signCursor
    }

    return this.context.form.cursor.select(props.signFieldPath.split('.'))
  },

  onEraClick() {
    this.cursors.sign.apply((x) => !x)
    if (!_.isNull(this.state.value)) {
      this.setDirtyState()
    }

    this.props.onChange()
  },

  toInternal(value) {
    if (!value && value !== 0) {
      return null
    }

    const strValue = String(value)
      .replace(/\D+/g, '')
      .replace(/^0+(?=\d)/, '')
    if (strValue === '') {
      return null
    }

    return _.toNumber(strValue)
  },

  toRepresentation(value) {
    if (_.isNull(value)) {
      return ''
    }

    return String(value)
  },

  getCurrentEra() {
    const { gettext } = this.props

    return this.state.sign ? gettext('BCE') : gettext('CE')
  },

  resetValue() {
    this.cursors.value.set(null)
    this.cursors.sign.set(false)
    this.props.onChange()
  },

  render() {
    return (
      <div
        className={classNames(s.year, s[this.props.classNameMod], {
          [s._reset]: this.props.canValueBeDiscarded,
        })}
      >
        <div className={s.label}>{this.props.label}:</div>
        <Input
          className={s.input}
          // disabled={this.props.disabled}
          cursor={this.cursors.value}
          onSync={this.props.onChange}
          id={this.props.id}
          toInternal={this.toInternal}
          toRepresentation={this.toRepresentation}
          nullable={this.props.nullable}
        />
        <button
          className={s.era__btn}
          disabled={this.props.disabled}
          type="button"
          title={this.props.gettext('Click to change')}
          onClick={this.onEraClick}
        >
          {this.getCurrentEra()}

          <FontAwesomeIcon icon={faCaretDown} className={s.icon} />
        </button>
        {this.props.canValueBeDiscarded &&
          (this.state.value || this.state.value === 0) && (
            <div className={s.reset__btn} onClick={this.resetValue} />
          )}
      </div>
    )
  },
})

export default withGettext(YearSelect)
